module.exports = __webpack_public_path__ + "static/media/memory_game_lg.127895ad.jpg";